import { lighten, rem } from 'polished';
import styled from 'styled-components';

const HuePickerPointer = styled.div`
    background-color: ${({ theme }) => lighten(0.4, theme.site.stage.backgroundColor)};
    border-radius: ${rem(2)};
    box-shadow: ${({ theme }) => theme.base.boxShadow.elevationSmall};
    cursor: pointer;
    height: ${rem(32)};
    margin-top: -${rem(6)};
    opacity: 0.7;
    transition: all 0.3s ease-in-out;
    width: ${rem(8)};

    &:hover,
    &:focus,
    &:active {
        opacity: 0.9;
        transform: scale(1.35, 1.15);
    }
`;

export default HuePickerPointer;
